<template>
  <v-app>
    <Navigations :breadcrumbs="this.breadcrumb" />
    <v-main>
      <v-container>
        <v-row class="pb-2">
          <v-col cols="4">
            <v-btn color="primary" text to="/profiles">
              <v-icon color="primary">mdi-arrow-left</v-icon>
              <v-list-item-title class="ma-0">Overzicht</v-list-item-title>
            </v-btn>
            <h1 class="font-weight-bold d-none">Profiel</h1>
          </v-col>
          <v-col cols="8" class="ml-auto text-right">
            <v-btn color="secondary" elevation="0" to="/card-profile"
              >Preview card profiel</v-btn
            >
          </v-col>
        </v-row>

        <div class="kyano-card-profile-banner">
          <div class="kyano-profile-banner-upload">
            <v-img
              class="m-auto text-center"
              width="100%"
              height="300px"
              src="../../assets/card-profile-default-banner.png"
            >
            </v-img>
            <v-file-input hide-input prepend-icon="mdi-camera"></v-file-input>
          </div>
        </div>
        <div class="kyano-card-profile-image">
          <div class="kyano-profile-upload">
            <v-img
              class="m-auto text-center"
              width="200px"
              height="200px"
              src="../../assets/profielfoto-linkedin.png"
            >
            </v-img>
            <v-file-input
              class="position-right-absolute"
              hide-input
              prepend-icon="mdi-camera"
            ></v-file-input>
          </div>
          <div class="text-center">
            <h5 class="profile-name">
              {{ data.firstname }} {{ data.lastname }}
            </h5>
            <p>{{ data.functiontitle }}</p>
          </div>
        </div>

        <!--  -->
        <v-card elevation="0" color="#FFF" class="rounded-md mb-5">
          <v-tabs color="primary" v-model="tab" class="fixed-tabs-bar" center-active centered>
            <v-tab> Mijn gegevens </v-tab>
            <v-tab> Bedrijfsgegevens</v-tab>
            <v-tab> Social media </v-tab>
            <v-tab> Collega's </v-tab>
            <v-tab> Instellingen </v-tab>
          </v-tabs>
        </v-card>
        <v-tabs-items color="#FAFBFD" v-model="tab" light class="bg-#FAFBFD">
          <v-tab-item>
            <v-card elevation="0" outlined class="border rounded-lg mb-5">
              <v-list>
                <template v-for="(item, index) in personalitems">
                  <v-row v-if="item.header" :key="item.header">
                    <v-col cols="12">
                      <v-subheader
                        v-text="item.header"
                        color="primary"
                        class="headline font-weight-bold pa-4 mb-0 text-primary"
                      ></v-subheader>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p
                        v-if="item.content"
                        :key="item.content"
                        v-text="item.content"
                        class="px-4"
                      ></p>
                    </v-col>
                  </v-row>

                  <v-divider v-else-if="item.divider" :key="index"></v-divider>

                  <v-list-item
                    v-else
                    :key="item.title"
                    :to="item.to"
                    class="py-2"
                  >
                    <v-list-item-content>
                      <strong v-html="item.subject"></strong>

                      <v-list-item-title
                        v-html="item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-icon class="font-size-small"
                      >fal fa-chevron-right</v-icon
                    >
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card elevation="0" outlined class="border rounded-lg mb-5">
              <template v-for="item in companyitems">
                <v-row v-if="item.header" :key="item.header">
                  <v-col cols="12">
                    <v-subheader
                      v-text="item.header"
                      color="primary"
                      class="headline font-weight-bold pa-4 mb-0 text-primary"
                    ></v-subheader>
                  </v-col>
                </v-row>
              </template>
              <div class="pa-4">
                <template class="pa-3" v-for="item in companyitems">
                  <strong v-if="item.companyname" :key="item.companyname">{{
                    item.companyname
                  }}</strong>
                  <p v-if="item.adres_complete" :key="item.adres_complete">
                    {{ item.adres_complete }}
                  </p>

                  <div
                    v-if="item.phonenumber"
                    :key="item.phonenumber"
                    class="d-flex"
                  >
                    <v-icon color="secondary" class="mr-2"
                      >fal fa-phone-rotary</v-icon
                    >
                    <p
                      v-if="item.phonenumber"
                      :key="item.phonenumber"
                      class="mb-0 my-auto"
                    >
                      {{ item.phonenumber }}
                    </p>
                  </div>
                  <div
                    v-if="item.emailadres"
                    :key="item.emailadres"
                    class="d-flex"
                  >
                    <v-icon color="secondary" class="mr-2"
                      >fal fa-envelope</v-icon
                    >

                    <p
                      class="my-auto"
                      v-if="item.emailadres"
                      :key="item.emailadres"
                    >
                      {{ item.emailadres }}
                    </p>
                  </div>

                  <p v-if="item.kvk_number" :key="item.kvk_number">
                    {{ item.kvk_number }}
                  </p>
                </template>
              </div>
              <v-divider></v-divider>
              <v-btn
                block
                elevation="0"
                class="text-left"
                text
                color="primary"
                to="/companies/1"
              >
                Bewerk bedrijf
              </v-btn>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card elevation="0" outlined class="border rounded-lg my-5">
            </v-card>
          </v-tab-item>
               <v-tab-item>
            <v-card elevation="0" outlined class="border rounded-lg my-5">
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card elevation="0" outlined class="border rounded-lg my-5">
              <v-list>
                <v-row>
                  <v-col cols="12">
                    <v-subheader
                      v-text="'Instellingen'"
                      color="primary"
                      class="headline font-weight-bold pa-4 mb-0 text-primary"
                    ></v-subheader>
                  </v-col>
                </v-row>

                <v-list-item class="py-2">
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="'Profiel verwijderen'"
                    ></v-list-item-title>
                  </v-list-item-content>
                  <v-btn elevation="0" color="danger" text>Verwijderen</v-btn>
                </v-list-item>
                <v-divider></v-divider>
              </v-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <!--  -->
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Navigations from "../../components/Navigations.vue";

export default {
  components: {
    Navigations,
  },
  props: {
    profiles: Array,
  },

  data() {
    return {
      tab: null,
      breadcrumb: [
        {
          text: "Profielen",
          disabled: false,
          href: "/profiles",
        },
        {
          text: "Voornaam Achternaam",
          disabled: false,
          href: `/profiles/${this.$route.params.id}`,
        },
      ],

      data: {
        firstname: "Gianni",
        lastname: "Hesseling",
        functiontitle: "Developer",
      },

      personalitems: [
        {
          header: "Mijn gegevens",
        },
        {
          subject: "Naam",
          title: "Gianni Hesseling",
          to: `/profiles/1/edit-name`,
        },
        { divider: true, inset: false },
        {
          subject: "Functietitel",
          title: "Developer",
          to: `/profiles/1/edit-functiontitle`,
        },
        { divider: true, inset: false },
        {
          subject: "E-mailadres",
          title: "Gianni@snelwebcenter.nl",
          to: `/profiles/1/edit-emailadres`,
        },
        { divider: true, inset: false },
        {
          subject: "Telefoonnummer",
          title: "0615234393",
          to: `/profiles/1/edit-phone`,
        },
      ],

      companyitems: [
        {
          header: "Bedrijfsgegevens",
        },
        {
          companyname: "Snelwebcenter",
          adres_complete: "Moermanskweg 2-22, 9723HM Groningen",
          phonenumber: "0850123456",
          emailadres: "info@snelwebcenter.nl",
          kvk_number: "688133449",
          iban: "NL12344556688",
          vat: "NL2312345678",
        },
      ],

      profilesettings: [
        {
          header: "Profiel beheren",
        },
        {
          title: "Profiel verwijderen",
          to: "",
        },
        { divider: true, inset: false },
        {
          subject: "Functietitel",
          title: "Developer",
          to: "/profiles/1/edit-functiontitle",
        },
      ],
    };
  },
};
</script>
<style>
.fixed-tabs-bar .v-tabs__bar {
  position: -webkit-sticky;
  position: sticky;
  top: 4rem;
  z-index: 2;
}
.theme--light.v-tabs-items {
  background: #fafbfd !important;
}
.kyano-profile-banner-upload {
  position: relative;
}

.kyano-profile-banner-upload .v-input .v-icon {
  z-index: 2;
  position: absolute;
  right: 20px;
  bottom: 65px;
  background: #ffffff40;
  border-radius: 100px;
  width: 40px;
  height: 40px;
  text-align: center;
  color: #ffffff;
  border: 1px solid #ffffff;
}

.kyano-profile-banner-upload .v-input:hover .v-icon {
  background: #ffffff50;
  color: #fff;
}

@media (max-width: 768px) {
  .kyano-profile-banner-upload .v-input .v-icon {
    top: 145px;
  }
}

.kyano-profile-upload {
  width: 200px;
  margin: auto;
  position: relative;
}
.kyano-profile-upload .v-input {
  position: absolute;
  right: 0;
}

.kyano-profile-upload .v-input .v-icon {
  z-index: 2;
  position: absolute;
  right: 20px;
  bottom: 50px;
  background: #011a6240;
  border-radius: 100px;
  width: 40px;
  height: 40px;
  text-align: center;
  color: #011a62;
  border: 1px solid #011a62;
}

.kyano-profile-upload .v-input:hover .v-icon {
  background: #011a6250;
  color: #011a62;
}

.profile-name {
  font-size: 35px;
  font-weight: bold;
}
.kyano-card-profile-banner {
  border-radius: 8px;
  overflow: hidden;
}

.kyano-card-profile-image {
  position: relative;
  margin-top: -75px;
}
.kyano-card-profile-image img {
  border-radius: 100px;
  margin-bottom: 20px;
  width: 150px;
  height: 150px;
}
@media (max-width: 768px) {
  .kyano-card-profile-banner {
    height: 200px;
  }
  .v-slide-group__prev {
    display: none !important;
  }
}

.v-tabs .v-tabs-slider-wrapper {
  transition: none;
}
.v-window__container {
  min-height: 100vh;
}
</style>
